import { Injectable, PLATFORM_ID, inject, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

type Lang = 'en' | 'mm';

const translations: Record<string, Record<Lang, string>> = {

  'nav.title': { en: "Ta'ang Education Fund Lottery", mm: "Ta'ang Education Fund Lottery" },
  'nav.purchase': { en: 'Get Purchase PDF File', mm: 'ဝယ်ယူမှု ဖိုင်ရယူရန်' },
  'nav.ticket': { en: 'Buy', mm: 'ဝယ်မည်' },

  'ticket.allAlphabets': { en: 'All Alphabets', mm: 'အားလုံး' },
  'ticket.number': { en: 'Number', mm: 'နံပါတ်' },
  'ticket.randomTickets': { en: 'Random Tickets', mm: 'ကျပန်းရွေးချယ်' },
  'ticket.noResultImage': { en: 'No Result Image', mm: 'ရလဒ်ဓာတ်ပုံ မရှိပါ' },
  'ticket.show': { en: 'Show', mm: 'ပြသရန်' },

  'payment.title': { en: 'Payment Summary', mm: 'ငွေပေးချေမှု အကျဉ်းချုပ်' },
  'payment.name': { en: 'Name', mm: 'အမည်' },
  'payment.address': { en: 'Address', mm: 'လိပ်စာ' },
  'payment.phone': { en: 'Phone', mm: 'ဖုန်းနံပါတ်' },
  'payment.nameRequired': { en: 'Name is required', mm: 'အမည် ဖြည့်ရန် လိုအပ်သည်' },
  'payment.addressRequired': { en: 'Address is required', mm: 'လိပ်စာ ဖြည့်ရန် လိုအပ်သည်' },
  'payment.phoneRequired': { en: 'Phone is required', mm: 'ဖုန်းနံပါတ် ဖြည့်ရန် လိုအပ်သည်' },
  'payment.selectedTickets': { en: '🎟 Selected Tickets', mm: '🎟 ရွေးချယ်ထားသောလက်မှတ်များ' },
  'payment.noTickets': { en: 'No tickets selected', mm: 'လက်မှတ် မရွေးချယ်ရသေးပါ' },
  'payment.method': { en: '💳 Payment Method', mm: '💳 ငွေပေးချေမှု နည်းလမ်း' },
  'payment.uploadScreenshot': { en: 'Upload Screenshot', mm: 'Screenshot တင်ရန်' },
  'payment.cancel': { en: 'Cancel', mm: 'မလုပ်တော့ပါ' },
  'payment.confirm': { en: 'Confirm', mm: 'အတည်ပြုရန်' },
  'payment.processing': { en: 'Processing...', mm: 'လုပ်ဆောင်နေသည်...' },

  'account.name': { en: 'Name', mm: 'အမည်' },
  'account.phone': { en: 'Phone', mm: 'ဖုန်း' },

  'invoice.success': { en: 'Payment Successful!', mm: 'ငွေပေးချေမှု အောင်မြင်ပါသည်!' },
  'invoice.no': { en: 'Invoice No:', mm: 'ကြေညာလွှာ နံပါတ်:' },

  'purchase.title': { en: 'Purchase', mm: 'ဝယ်ယူမှု' },
  'purchase.searchPlaceholder': { en: 'Search Invoiceno', mm: 'ကြေညာလွှာနံပါတ် ရှာရန်' },
  'purchase.export': { en: 'Export', mm: 'ထုတ်ယူရန်' },
  'purchase.exporting': { en: 'Exporting...', mm: 'ထုတ်ယူနေသည်...' },
  'purchase.statusPending': { en: 'Pending', mm: 'လက်ခံဆဲ' },
  'purchase.statusFailed': { en: 'Failed', mm: 'မအောင်မြင်ပါ' },
  'purchase.labelName': { en: 'Name', mm: 'အမည်' },
  'purchase.labelPhone': { en: 'Phone', mm: 'ဖုန်း' },
  'purchase.labelAddress': { en: 'Address', mm: 'လိပ်စာ' },
  'purchase.labelDate': { en: 'Date', mm: 'ရက်စွဲ' },
  'purchase.searching': { en: 'Searching for your purchase...', mm: 'ဝယ်ယူမှု ရှာဖွေနေသည်...' },
  'purchase.noResults': { en: 'No results found for your search.', mm: 'ရှာဖွေမှု ရလဒ် မတွေ့ပါ' },
  'purchase.tryAgain': { en: 'Please check the invoice number and try again.', mm: 'ကြေညာလွှာနံပါတ် စစ်ဆေးပြီး ထပ်မံကြိုးစားပေးပါ' },


  'admin.lottery': { en: 'Lottery', mm: 'ထီလက်မှတ်' },
  'admin.management': { en: 'Management', mm: 'စီမံခန့်ခွဲမှု' },
  'admin.dashboard': { en: 'Dashboard', mm: 'ဒက်ရှ်ဘုတ်' },
  'admin.ticket': { en: 'Ticket', mm: 'လက်မှတ်' },
  'admin.confirmed-order': { en: 'Confirmed Order', mm: 'အတည်ပြုပြီး အော်ဒါ' },
  'admin.card': { en: 'Card', mm: 'ကတ်' },
  'admin.account': { en: 'Account', mm: 'အကောင့်' },
  'admin.order': { en: 'Order', mm: 'အော်ဒါ' },
  'admin.result': { en: 'Result', mm: 'ရလဒ်' },
  'admin.settings': { en: 'Settings', mm: 'ဆက်တင်' },
  'admin.signOut': { en: 'Sign Out', mm: 'ထွက်မည်' },
  'admin.signOutConfirm': { en: 'Sign Out?', mm: 'ထွက်မည်လား?' },
  'admin.signOutMsg': { en: 'Are you sure you want to sign out?', mm: 'ထွက်ရန် သေချာပါသလား?' },
  'admin.cancel': { en: 'Cancel', mm: 'မလုပ်တော့ပါ' },
  'admin.ticketList': { en: 'Ticket List', mm: 'လက်မှတ်များ စာရင်း' },
  'admin.orderList': { en: 'Order List', mm: 'အော်ဒါများ စာရင်း' },
  'admin.cardList': { en: 'Card List', mm: 'ကတ်များ စာရင်း' },
  'admin.accountList': { en: 'Account List', mm: 'အကောင့်များ စာရင်း' },
  'admin.lotteryList': { en: 'Lottery List', mm: 'ထီစာရင်း' },
  'admin.resultList': { en: 'Result List', mm: 'ရလဒ်များ စာရင်း' },
  'admin.dashboardNotFound': { en: 'Dashboard Under Construction', mm: 'ဒက်ရှ်ဘုတ်ကို ပြုပြင်နေဆဲဖြစ်ပါသည်' },
  'admin.dashboardError': { en: 'The dashboard feature is currently being developed. Please check other modules.', mm: 'ဒက်ရှ်ဘုတ်စနစ်ကို လက်ရှိတွင် ထုတ်လုပ်နေဆဲဖြစ်ပါသည်။ အခြားသော ကဏ္ဍများကို စစ်ဆေးပေးပါ။' },
  'admin.dashboard.ticketRevenue': { en: 'Ticket Revenue', mm: 'လက်မှတ် ရရှိငွေ' },
  'admin.dashboard.ticketOverview': { en: 'Ticket Overview', mm: 'လက်မှတ်များ အကျဉ်းချုပ်' },
  'admin.dashboard.orderOverview': { en: 'Order Overview', mm: 'အော်ဒါများ အကျဉ်းချုပ်' },
  'admin.dashboard.orders': { en: 'Orders', mm: 'အော်ဒါများ' },
  'admin.dashboard.recentOrders': { en: 'Recent Orders', mm: 'နောက်ဆုံးအော်ဒါများ' },


  'column.ticketNo': { en: 'Ticket No', mm: 'လက်မှတ်နံပါတ်' },
  'column.alphabet': { en: 'Alphabet', mm: 'အက္ခရာ' },
  'column.number': { en: 'Number', mm: 'နံပါတ်' },
  'column.status': { en: 'Status', mm: 'အခြေအနေ' },
  'column.action': { en: 'Action', mm: 'လုပ်ဆောင်ချက်' },
  'column.invoiceNo': { en: 'Invoice No', mm: 'ကြေညာလွှာနံပါတ်' },
  'column.name': { en: 'Name', mm: 'အမည်' },
  'column.address': { en: 'Address', mm: 'လိပ်စာ' },
  'column.phone': { en: 'Phone', mm: 'ဖုန်း' },
  'column.screenshot': { en: 'Screenshot', mm: 'Screenshot' },
  'column.ticketCount': { en: 'Ticket Count', mm: 'လက်မှတ်အရေအတွက်' },
  'column.icon': { en: 'Icon', mm: 'အိုင်ကွန်' },
  'column.price': { en: 'Price', mm: 'စျေးနှုန်း' },
  'column.date': {en: 'Date', mm: 'ရက်စွဲ'},
  'column.card': { en: 'Card', mm: 'ကတ်' },
  'column.accountimg': { en: 'Account Image', mm: 'အကောင့်ပုံ' },
  'column.QR': { en: 'QR Code', mm: 'QR Code' },
  'column.no': { en: 'No.', mm: 'စဉ်' },
  'column.remark': { en: 'Remark', mm: 'မှတ်ချက်' },

  'login.phone': { en: 'Phone Number', mm: 'ဖုန်းနံပါတ်' },
  'login.phonePlaceholder': { en: 'Enter Your Email or Phone', mm: 'အီးမေးလ် သို့မဟုတ် ဖုန်းနံပါတ်ထည့်ပါ' },
  'login.phoneRequired': { en: 'Valid phone number is required', mm: 'သက်မှတ်ဖုန်းနံပါတ် လိုအပ်ပါသည်' },
  'login.password': { en: 'Password', mm: 'စကားဝှက်' },
  'login.passwordPlaceholder': { en: 'Enter Your Password', mm: 'စကားဝှက်ထည့်ပါ' },
  'login.passwordRequired': { en: 'Password is required', mm: 'စကားဝှက် လိုအပ်ပါသည်' },
  'login.passwordMin': { en: 'Min 6 characters', mm: 'အနည်းဆုံး စာလုံး ၆ လုံး' },
  'login.signIn': { en: 'Sign In', mm: 'ဝင်မည်' },
  'login.processing': { en: 'Processing...', mm: 'လုပ်ဆောင်နေသည်...' },

  'table.total': { en: 'Total', mm: 'စုစုပေါင်း' },
  'table.allTime': { en: 'All Time', mm: 'အချိန်များ' },
  'table.allAlphabets': { en: 'All Alphabets', mm: 'အားလုံး' },
  'table.allStatus': { en: 'All Status', mm: 'အခြေအနေ' },
  'table.search': { en: 'Search...', mm: 'ရှာရန်...' },
  'table.import': { en: 'Import', mm: 'တင်သွင်းရန်' },
  'table.createNew': { en: 'Create New', mm: 'အသစ်ဖန်တီးရန်' },
  'table.noResults': { en: 'No results found for', mm: 'ရလဒ်မတွေ့ပါ :' },
  'table.page': { en: 'Page', mm: 'စာမျက်နှာ' },
  'table.of': { en: 'of', mm: '၏' },
  'table.previous': { en: 'Previous', mm: 'ယခင်' },
  'table.next': { en: 'Next', mm: 'နောက်' },
  'table.statusOpen': { en: 'Open', mm: 'Open' },
  'table.statusPending': { en: 'Pending', mm: 'Pending' },
  'table.statusConfirmed': { en: 'Confirmed', mm: 'Confirmed' },
  'table.statusFailed': { en: 'Failed', mm: 'Failed' },
  'table.statusReserved': { en: 'Reserved', mm: 'Reserved' },

  'table.rangeToday': { en: 'Today', mm: 'ယနေ့' },
  'table.rangeYesterday': { en: 'Yesterday', mm: 'မနေ့က' },
  'table.rangeWeek': { en: 'This Week', mm: 'ယခုသီတင်းပတ်' },
  'table.rangeMonth': { en: 'This Month', mm: 'ယခုလ' },

  'month.01': { en: 'January', mm: 'ဇန်နဝါရီ' },
  'month.02': { en: 'February', mm: 'ဖေဖော်ဝါရီ' },
  'month.03': { en: 'March', mm: 'မတ်' },
  'month.04': { en: 'April', mm: 'ဧပြီ' },
  'month.05': { en: 'May', mm: 'မေ' },
  'month.06': { en: 'June', mm: 'ဇွန်' },
  'month.07': { en: 'July', mm: 'ဇူလိုင်' },
  'month.08': { en: 'August', mm: 'ဩဂုတ်' },
  'month.09': { en: 'September', mm: 'စက်တင်ဘာ' },
  'month.10': { en: 'October', mm: 'အောက်တိုဘာ' },
  'month.11': { en: 'November', mm: 'နိုဝင်ဘာ' },
  'month.12': { en: 'December', mm: 'ဒီဇင်ဘာ' },

  'modal.editTicket': { en: 'Edit Ticket', mm: 'လက်မှတ် ပြင်ရန်' },
  'modal.createTicket': { en: 'Create New Ticket', mm: 'လက်မှတ်အသစ် ဖန်တီးရန်' },
  'modal.alphabet': { en: 'Alphabet', mm: 'အက္ခရာ' },
  'modal.ticketNumber': { en: 'Ticket Number', mm: 'လက်မှတ်နံပါတ်' },
  'modal.ticketNumberPlaceholder': { en: 'Enter ticket number', mm: 'လက်မှတ်နံပါတ် ထည့်ပါ' },
  'modal.updateTicket': { en: 'Update Ticket', mm: 'လက်မှတ် ပြင်ရန်' },
  'modal.createTicketBtn': { en: 'Create Ticket', mm: 'လက်မှတ် ဖန်တီးရန်' },
  'modal.saving': { en: 'Saving...', mm: 'သိမ်းနေသည်...' },
  'modal.addRow': { en: 'Add Ticket', mm: 'လက်မှတ်ထပ်ထည့်ရန်' },
  'modal.editOrder': { en: 'Edit Order', mm: 'အော်ဒါ ပြင်ရန်' },
  'modal.status': { en: 'Status', mm: 'အခြေအနေ' },
  'modal.updateOrder': { en: 'Update Order', mm: 'အော်ဒါ ပြင်ရန်' },
  'modal.editCard': { en: 'Edit Card', mm: 'ကတ် ပြင်ရန်' },
  'modal.createCard': { en: 'Create New Card', mm: 'ကတ်အသစ် ဖန်တီးရန်' },
  'modal.uploadIcon': { en: 'Upload Icon', mm: 'အိုင်ကွန် တင်ရန်' },
  'modal.name': { en: 'Name', mm: 'အမည်' },
  'modal.enterName': { en: 'Enter Name', mm: 'အမည် ထည့်ပါ' },
  'modal.updateCard': { en: 'Update Card', mm: 'ကတ် ပြင်ရန်' },
  'modal.createCardBtn': { en: 'Create Card', mm: 'ကတ် ဖန်တီးရန်' },
  'modal.editAccount': { en: 'Edit Account', mm: 'အကောင့် ပြင်ရန်' },
  'modal.createAccount': { en: 'Create New Account', mm: 'အကောင့်အသစ် ဖန်တီးရန်' },
  'modal.card': { en: 'Card', mm: 'ကတ်' },
  'modal.phone': { en: 'Phone', mm: 'ဖုန်း' },
  'modal.enterPhone': { en: 'Enter Phone', mm: 'ဖုန်းနံပါတ် ထည့်ပါ' },
  'modal.updateAccount': { en: 'Update Account', mm: 'အကောင့် ပြင်ရန်' },
  'modal.createAccountBtn': { en: 'Create Account', mm: 'အကောင့် ဖန်တီးရန်' },
  'modal.editLottery': { en: 'Edit Lottery', mm: 'ထီလက်မှတ်ပြင်ရန်' },
  'modal.createLottery': { en: 'Create New Lottery', mm: 'ထီအသစ် ဖန်တီးရန်' },
  'modal.price': { en: 'Price', mm: 'စျေးနှုန်း' },
  'modal.enterPrice': { en: 'Enter Price', mm: 'စျေးနှုန်း ထည့်ပါ' },
  'modal.updateLottery': { en: 'Update Lottery', mm: 'ထီလက်မှတ်ပြင်ရန်' },
  'modal.createLotteryBtn': { en: 'Create Lottery', mm: 'ထီလက်မှတ် ဖန်တီးရန်' },
  'modal.editResult': { en: 'Edit Result', mm: 'ရလဒ် ပြင်ရန်' },
  'modal.createResult': { en: 'Create New Result', mm: 'ရလဒ်အသစ် ဖန်တီးရန်' },
  'modal.updateResult': { en: 'Update Result', mm: 'ရလဒ် ပြင်ရန်' },
  'modal.createResultBtn': { en: 'Create Result', mm: 'ရလဒ် ဖန်တီးရန်' },
  'modal.uploadScreenshot': { en: 'Upload Screenshot', mm: 'Screenshot တင်ရန်' },
  'modal.uploadQR': { en: 'Upload QR Code', mm: 'QR Code တင်ရန်' },
  'modal.QR': {en: 'QR Code', mm: 'QR Code'},
  'modal.change': { en: 'Change Image', mm: 'ပုံပြောင်းရန်' },
  'modal.accountimg': { en: 'Upload Image', mm: 'ပုံတင်ရန်' },
  
  'alert.deleteConfirm': { en: 'Are you sure you want to delete this?', mm: 'ဤအရာကို ဖျက်ရန် သေချာပါသလား?' },
  'alert.deleteTicketConfirm': { en: 'Are you sure you want to delete ticket?', mm: 'ဤလက်မှတ်ကို ဖျက်ရန် သေချာပါသလား?' },
  'alert.deleteSuccess': { en: 'Deleted successfully', mm: 'ဖျက်သိမ်းမှု အောင်မြင်ပါသည်' },
  'alert.deleteError': { en: 'Failed to delete', mm: 'ဖျက်သိမ်းမှု မအောင်မြင်ပါ' },
  'alert.updateSuccess': { en: 'Updated successfully', mm: 'ပြင်ဆင်မှု အောင်မြင်ပါသည်' },
  'alert.updateError': { en: 'Failed to update', mm: 'ပြင်ဆင်မှု မအောင်မြင်ပါ' },
  'alert.createSuccess': { en: 'Created successfully', mm: 'ဖန်တီးမှု အောင်မြင်ပါသည်' },
  'alert.createError': { en: 'Failed to create', mm: 'ဖันတီးမှု မအောင်မြင်ပါ' },
  'alert.importSuccess': { en: 'Successfully imported {{count}} items', mm: 'အချက်အလက် {{count}} ခု တင်သွင်းမှု အောင်မြင်ပါသည်' },
  'alert.importError': { en: 'Failed to import', mm: 'တင်သွင်းမှု မအောင်မြင်ပါ' },
  'alert.noDataExcel': { en: 'No data found in Excel file', mm: 'Excel ဖိုင်တွင် အချက်အလက်မရှိပါ' },
  'alert.noValidTicketData': { en: 'No valid ticket data found in file. Please ensure your Excel file has columns named "Alphabet" and "Number".', mm: 'ဖိုင်တွင် မှန်ကန်သော လက်မှတ်အချက်အလက် မတွေ့ပါ။ "Alphabet" နှင့် "Number" ကော်လံများ ပါဝင်ကြောင်း စစ်ဆေးပေးပါ။' },
  'alert.invalidExcel': { en: 'No valid data found in file', mm: 'ဖိုင်တွင် မှန်ကန်သော အချက်အလက်မတွေ့ပါ' },
  'alert.errorOccurred': { en: 'An error occurred', mm: 'အမှားတစ်ခု ဖြစ်ပွားခဲ့သည်' },
};

@Injectable({ providedIn: 'root' })
export class TranslationService {
  private readonly USER_STORAGE_KEY = 'user_language';
  private readonly ADMIN_STORAGE_KEY = 'admin_language';
  private platformId = inject(PLATFORM_ID);

  private getStoredLang(key: string): Lang {
    if (isPlatformBrowser(this.platformId)) {
      return (localStorage.getItem(key) as Lang) || 'en';
    }
    return 'en';
  }

  userLang = signal<Lang>(this.getStoredLang(this.USER_STORAGE_KEY));
  adminLang = signal<Lang>(this.getStoredLang(this.ADMIN_STORAGE_KEY));

  get currentLang() { return this.userLang; }

  setLanguage(lang: Lang): void {
    this.setUserLanguage(lang);
  }

  setUserLanguage(lang: Lang): void {
    this.userLang.set(lang);
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(this.USER_STORAGE_KEY, lang);
    }
  }

  setAdminLanguage(lang: Lang): void {
    this.adminLang.set(lang);
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(this.ADMIN_STORAGE_KEY, lang);
    }
  }

  translate(key: string, params?: Record<string, any>): string {
    const entry = translations[key];
    if (!entry) {
      return key;
    }
    
    const isAdminKey = key.startsWith('admin.') || 
                      key.startsWith('column.') || 
                      key.startsWith('table.') || 
                      key.startsWith('modal.') || 
                      key.startsWith('alert.') ||
                      key.startsWith('login.') ||
                      key.startsWith('month.');
    
    const activeLang = isAdminKey ? this.adminLang() : this.userLang();
    let text = entry[activeLang] ?? entry['en'] ?? key;
    
    if (params) {
      Object.keys(params).forEach(param => {
        text = text.replace(`{{${param}}}`, params[param]);
      });
    }
    
    return text;
  }
}
